import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute }           from '@angular/router';

import { AuthenticationService } from '../../../../core/auth/authentication.service';
import { MatIcon }               from '@angular/material/icon';
import { ButtonComponent }       from '../../../../shared/components/buttons/button.component';
import { MatProgressSpinner }    from '@angular/material/progress-spinner';

@Component({
  selector: 'pin-confirm-registration',
  templateUrl: './confirm-registration.component.html',
  imports: [MatIcon, ButtonComponent, MatProgressSpinner]
})
export class ConfirmRegistrationComponent implements OnInit {
  isLoading = true;
  icon;
  message;
  private route = inject(ActivatedRoute);
  private authService = inject(AuthenticationService);

  ngOnInit() {    const queryParams = this.route.snapshot.queryParamMap;
    const userId: string = queryParams.get('uid');
    const code: string = queryParams.get('key');

    this.authService.confirmRegistration(userId, code).subscribe({
      next: () => {
        this.message = 'Thank you for verifying your account.';
        this.icon = 'check_circle';
        this.isLoading = false;
      },
      error: () => {
        this.icon = 'cancel';
        this.message = 'This link is no longer valid.';
        this.isLoading = false;
      }
    });
  }
}
